module.exports = {
	"version": "0.16.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/web3/lib/version.json
// module id = 440
// module chunks = 0